// NOTE: IF YOU CHANGE THE CONTENT HERE YOU NEED TO CHANGE THE CONTENT ON THE WRAPPED CALCULATOR HERE AND ON WEBSITE TOO

import './assets/css/index.css'

import { Accordion, AccordionItem, Link } from '@nextui-org/react'

import { Calculator, CalculatorProps } from './calculator'

const logo = new URL('./assets/images/logotype_bold_light.svg', import.meta.url)

export function WrappedCalculator(props: CalculatorProps) {
  return (
    <div className="bg-[#F6F6F4]">
      <div className="mx-auto max-w-4xl px-4 sm:px-7">
        <div className="flex items-center justify-between py-8">
          <a
            className="-m-2.5 inline-block cursor-pointer p-2.5 hover:bg-[#2c97d1]"
            href="https://www.sleeve.fm/"
          >
            <img src={logo.toString()} className="select-none" />
          </a>
        </div>
      </div>
      <article className="font mx-auto min-h-fit max-w-4xl p-4 pb-32 font-sans sm:p-7">
        <h1 className="mb-3 text-balance text-2xl font-bold leading-tight tracking-tighter sm:mb-6 sm:text-3xl md:text-5xl md:leading-none lg:text-6xl">
          A few true fans can change everything.
        </h1>
        <Accordion
          className="p-0"
          hideIndicator
          itemClasses={{
            base: 'base',
            heading: 'heading',
            trigger: 'p-0 trigger group/trigger',
          }}
        >
          <AccordionItem
            key="1"
            aria-label="Description"
            title={
              <p className="prose prose-sm">
                Kevin Kelly&apos;s idea in{' '}
                <Link
                  size="sm"
                  color="foreground"
                  className="underline underline-offset-2 hover:no-underline"
                  target="_blank"
                  href="https://kk.org/thetechnium/1000-true-fans/"
                >
                  1,000 True Fans
                </Link>{' '}
                is simple but powerful: you don&apos;t need to go viral to make
                a living. A small group of dedicated listeners can support your
                career — through memberships, album sales, livestreams, and
                more.{' '}
                <span className="font-bold transition group-data-[open=true]/trigger:hidden">
                  Read more...
                </span>
              </p>
            }
          >
            <p className="prose prose-sm">
              Sleeve helps you turn that idea into income. This calculator shows
              how much you could earn through monthly fan memberships alone. Add
              in revenue from other features like album sales and livestreams,
              and the potential grows.
            </p>
          </AccordionItem>
        </Accordion>
        <Calculator {...props} />
        <div className="mt-6 flex flex-col border-t border-slate-300 pt-4">
          <h3 className="prose-lg font-semibold">Understanding the Data</h3>
          <div className="grid gap-2">
            <p className="prose prose-sm text-balance">
              This calculator models recurring income from memberships only.
              Earnings from music sales, livestreams, and other direct offers
              aren&apos;t included here — but they can be powerful
              additions. Sleeve takes zero rake, so you keep 100% of what your
              fans pay. Estimates account for average payment processing fees
              (~6%), which vary by country, currency, and method.
            </p>
          </div>
        </div>
      </article>
    </div>
  )
}
